import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { LeadsService } from '../services/leaderboard.service';
import { LeadsActionTypes } from './leaderboard.actions';
import { switchMap, map, catchError, withLatestFrom } from 'rxjs/operators';
import { Leaderboard } from '../models/leaderboard.model';

import * as fromLeads from './../store/leaderboard.actions';
import { of } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../reducers/index';
import { getUser } from '../../auth/store/auth.selectors';

@Injectable()
export class LeadsEffects {

  constructor(private actions$: Actions, private leadsService: LeadsService, private store: Store<AppState>) {}

  @Effect()
  query2$ = this.actions$.pipe(
    ofType(LeadsActionTypes.LEADS_QUERY2),
    withLatestFrom(this.store.pipe(select(getUser))),
    switchMap(([, user]: any) => this.leadsService.getUsers(user.uid)
      .pipe(
        map((data: any) => {
          const leadsData: Leaderboard[] = data.map((res: any) => {
            const key = res.payload.key;
            const leadUser: Leaderboard = res.payload.val();
            return {
              key: key,
              id: leadUser.id,
              name: leadUser.name, 
              allLeads: leadUser.allLeads,
              todayLeads: leadUser.todayLeads
              
            };
          });
          return (new fromLeads.LeadsLoaded({ leads: leadsData }));
        }),
        catchError(error => {
          return of(new fromLeads.LeadsError({ error }));
        })
      )
    ),
    
  );


  @Effect()
  query$ = this.actions$.pipe(
    ofType(LeadsActionTypes.LEADS_QUERY),
    withLatestFrom(this.store.pipe(select(getUser))),
    switchMap(([, user]: any) => this.leadsService.get(user.uid)
      .pipe(
        map((data: any) => {
          const leadsData: Leaderboard[] = data.map((res: any) => {
            const key = res.payload.key;
            const lead: Leaderboard = res.payload.val();
            return {
              key: key,
              id: lead.id,
              name: lead.name,
              description: lead.description,
              phone: lead.phone,
              page: lead.page,
              address: lead.address,
              postcode: lead.postcode,
              phone2: lead.phone2,
              status: lead.status, 
              industry: lead.industry,
              date: lead.date,
              hashtag: lead.hashtag,
              username: lead.username,
              lead: lead.lead,
              hashAll: lead.hashAll,
              hashMonth: lead.hashMonth,
              hashToday: lead.hashToday,
              hashWeek: lead.hashWeek,
              hashYear: lead.hashYear,
              hashcount: lead.hashcount,
              pulledCount: lead.pulledCount,
              leadCount: lead.leadCount,
              totalLeads: lead.totalLeads,
              allLeads: lead.allLeads,
              todayLeads: lead.todayLeads,
              nameUser: lead.nameUser,
              allLeadsChris: lead.allLeadsChris,
              nameUserChris: lead.nameUserChris,
              todayLeadsChris: lead.todayLeadsChris,
              allLeadsGabriella: lead.allLeadsGabriella,
              nameUserGabriella: lead.nameUserGabriella,
              todayLeadsGabriella: lead.todayLeadsGabriella,
              allLeadsMegan: lead.allLeadsMegan,
              allLeadsPhil: lead.allLeadsPhil,
              allLeadsbecca: lead.allLeadsbecca,
              nameUserMegan: lead.nameUserMegan,
              nameUserPhil: lead.nameUserPhil,
              nameUserbecca: lead.nameUserbecca,
              todayLeadsMegan: lead.todayLeadsMegan,
              todayLeadsPhil: lead.todayLeadsPhil,
              todayLeadsbecca: lead.todayLeadsbecca
            };
          });
          return (new fromLeads.LeadsLoaded({ leads: leadsData }));
        }),
        catchError(error => {
          return of(new fromLeads.LeadsError({ error }));
        })
      )
    ),
    
  );

  

  

  @Effect({ dispatch: false })
  added$ = this.actions$.pipe(
    ofType(LeadsActionTypes.LEADS_ADDED),
    map((action: fromLeads.LeadsAdded) => action.payload),
    withLatestFrom(this.store.pipe(select(getUser))),
    switchMap(([payload, user]: any) => this.leadsService.add(payload.lead, user.uid))
  );

  @Effect({ dispatch: false })
  edit$ = this.actions$.pipe(
    ofType(LeadsActionTypes.LEADS_EDITED),
    map((action: fromLeads.LeadsEdited) => action.payload),
    withLatestFrom(this.store.pipe(select(getUser))),
    switchMap(([payload, user]: any) => this.leadsService.update(payload.lead, user.uid)
    .pipe(
      catchError( error => {
      return of(new fromLeads.LeadsError({ error }));
    }))
    )
  );

  @Effect({ dispatch: false })
  save$ = this.actions$.pipe(
    ofType(LeadsActionTypes.LEADS_SAVED),
    map((action: fromLeads.LeadsSaved) => action.payload),
    withLatestFrom(this.store.pipe(select(getUser))),
    switchMap(([payload, user]: any) => this.leadsService.save(payload.lead, user.uid)
    .pipe(
      catchError( error => {
      return of(new fromLeads.LeadsError({ error }));
    }))
    )
  );

  @Effect({ dispatch: false })
  delete$ = this.actions$.pipe(
    ofType(LeadsActionTypes.LEADS_DELETED),
    map((action: fromLeads.LeadsDeleted) => action.payload),
    withLatestFrom(this.store.pipe(select(getUser))),
    switchMap(([payload, user]: any) => this.leadsService.delete(payload.lead, user.uid))
  );
}
